import React, { useState } from 'react';

type SyncState = 'synced' | 'syncing' | 'failed' | 'needs-reauth';

const ORDER: SyncState[] = ['synced', 'syncing', 'failed', 'needs-reauth'];

const META: Record<SyncState, { label: string; icon: string }> = {
  synced: { label: 'Synced', icon: '✓' },
  syncing: { label: 'Syncing…', icon: '↻' },
  failed: { label: 'Sync failed', icon: '!' },
  'needs-reauth': { label: 'Needs reauth', icon: '⚠' },
};

interface SyncBadgeProps {
  showHint?: boolean;
}

const SyncBadge: React.FC<SyncBadgeProps> = ({ showHint = true }) => {
  const [i, setI] = useState(0);
  const state = ORDER[i];
  const meta = META[state];

  return (
    <div className="cache__syncbadge-wrap">
      <button
        type="button"
        className={`cache__syncbadge cache__syncbadge--${state}`}
        onClick={() => setI(prev => (prev + 1) % ORDER.length)}
      >
        <span className="cache__syncbadge-dot" aria-hidden="true" />
        <span className="cache__syncbadge-icon" aria-hidden="true">{meta.icon}</span>
        <span className="cache__syncbadge-label">{meta.label}</span>
      </button>
      {showHint && <span className="cache__syncbadge-hint">Click to cycle states</span>}
    </div>
  );
};

export default SyncBadge;
